'use es6';

import { Record } from 'immutable';
import keyMirror from 'react-utils/keyMirror';
const States = keyMirror({
  NOT_UPDATED: null,
  HAS_UPDATED: null,
  SAVING: null,
  SAVING_SUCCEEDED: null,
  SAVING_HAS_ERROR: null,
  PUBLISHING: null
});
export default class UpdateState extends Record({
  state: States.NOT_UPDATED,
  message: null
}) {
  isNotUpdated() {
    return this.state === States.NOT_UPDATED;
  }
  hasUpdated() {
    return this.state === States.HAS_UPDATED;
  }
  isSaving() {
    return this.state === States.SAVING;
  }
  isSaveSuccessful() {
    return this.state === States.SAVING_SUCCEEDED;
  }
  hasFailedSaving() {
    return this.state === States.SAVING_HAS_ERROR;
  }
  isPublishing() {
    return this.state === States.PUBLISHING;
  }
  setMessage(value) {
    return this.set('message', value);
  }
  getMessage() {
    return this.get('message');
  }
}
export const NOT_UPDATED = new UpdateState({
  state: States.NOT_UPDATED
});
export const HAS_UPDATED = new UpdateState({
  state: States.HAS_UPDATED
});
export const SAVING = new UpdateState({
  state: States.SAVING
});
export const SAVING_SUCCEEDED = new UpdateState({
  state: States.SAVING_SUCCEEDED
});
export const SAVING_HAS_ERROR = new UpdateState({
  state: States.SAVING_HAS_ERROR
});
export const PUBLISHING = new UpdateState({
  state: States.PUBLISHING
});